import { render, staticRenderFns } from "wisaapp-webstudent/src/components/agenda/agenda.html?vue&type=template&id=abe8cd1e&"
import script from "wisaapp-webstudent/src/components/agenda/agenda.js?vue&type=script&lang=js&"
export * from "wisaapp-webstudent/src/components/agenda/agenda.js?vue&type=script&lang=js&"
import style0 from "wisaapp-webstudent/src/components/agenda/agenda.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports